export default __webpack_public_path__ + "static/media/truffleHog-long.1e31fd90.svg";